<template>
  <!-- todo : move this to ui directory as large icon -->
  <div class="navigation-icon">
    <svg
      width="29"
      height="27"
      viewBox="0 0 29 27"
      v-if="icon === 'chat'"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.26241 15.4125C1.14161 13.5341 0.748759 11.3132 1.15764 9.16692C1.56653 7.02069 2.74901 5.0968 4.48302 3.75656C6.21702 2.41633 8.38324 1.75197 10.5748 1.88827C12.7664 2.02456 14.8326 2.95212 16.3853 4.49675C17.938 6.04138 18.8705 8.0968 19.0075 10.277C19.1445 12.4572 18.4766 14.6121 17.1294 16.3371C15.7821 18.062 13.8482 19.2384 11.6907 19.6451C9.53323 20.0519 7.30071 19.6611 5.41241 18.5461L2.29991 19.429C2.17167 19.4649 2.03614 19.4661 1.90726 19.4326C1.77837 19.3991 1.66079 19.332 1.56659 19.2383C1.47239 19.1446 1.40499 19.0276 1.3713 18.8994C1.33761 18.7712 1.33886 18.6364 1.37491 18.5088L2.26241 15.4125Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.51245 19.7896C9.95301 21.0391 10.6671 22.1757 11.603 23.1172C12.539 24.0587 13.6735 24.7816 14.9246 25.2338C16.1757 25.6859 17.5121 25.8559 18.8373 25.7316C20.1625 25.6073 21.4434 25.1917 22.5875 24.5148V24.5148L25.7 25.3977C25.8282 25.4336 25.9637 25.4348 26.0926 25.4013C26.2215 25.3678 26.3391 25.3007 26.4333 25.207C26.5275 25.1133 26.5949 24.9963 26.6286 24.8681C26.6623 24.7399 26.661 24.6051 26.625 24.4775L25.7374 21.3812C26.5298 20.0582 26.9651 18.5539 27.0013 17.0143C27.0375 15.4747 26.6733 13.9519 25.944 12.5934C25.2147 11.235 24.145 10.0869 22.8386 9.26062C21.5322 8.43429 20.0334 7.95766 18.4875 7.87692"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="icon === 'x'"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8986 5.0116L5.0116 17.8986"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.8986 17.8986L5.0116 5.0116"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'menu'"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 9C8.32843 9 9 8.32843 9 7.5C9 6.67157 8.32843 6 7.5 6C6.67157 6 6 6.67157 6 7.5C6 8.32843 6.67157 9 7.5 9Z"
        fill="#212121"
      />
      <path
        d="M16 9C16.8284 9 17.5 8.32843 17.5 7.5C17.5 6.67157 16.8284 6 16 6C15.1716 6 14.5 6.67157 14.5 7.5C14.5 8.32843 15.1716 9 16 9Z"
        fill="#212121"
      />
      <path
        d="M24.5 9C25.3284 9 26 8.32843 26 7.5C26 6.67157 25.3284 6 24.5 6C23.6716 6 23 6.67157 23 7.5C23 8.32843 23.6716 9 24.5 9Z"
        fill="#212121"
      />
      <path
        d="M7.5 17.5C8.32843 17.5 9 16.8284 9 16C9 15.1716 8.32843 14.5 7.5 14.5C6.67157 14.5 6 15.1716 6 16C6 16.8284 6.67157 17.5 7.5 17.5Z"
        fill="#212121"
      />
      <path
        d="M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5Z"
        fill="#212121"
      />
      <path
        d="M24.5 17.5C25.3284 17.5 26 16.8284 26 16C26 15.1716 25.3284 14.5 24.5 14.5C23.6716 14.5 23 15.1716 23 16C23 16.8284 23.6716 17.5 24.5 17.5Z"
        fill="#212121"
      />
      <path
        d="M7.5 26C8.32843 26 9 25.3284 9 24.5C9 23.6716 8.32843 23 7.5 23C6.67157 23 6 23.6716 6 24.5C6 25.3284 6.67157 26 7.5 26Z"
        fill="#212121"
      />
      <path
        d="M16 26C16.8284 26 17.5 25.3284 17.5 24.5C17.5 23.6716 16.8284 23 16 23C15.1716 23 14.5 23.6716 14.5 24.5C14.5 25.3284 15.1716 26 16 26Z"
        fill="#212121"
      />
      <path
        d="M24.5 26C25.3284 26 26 25.3284 26 24.5C26 23.6716 25.3284 23 24.5 23C23.6716 23 23 23.6716 23 24.5C23 25.3284 23.6716 26 24.5 26Z"
        fill="#212121"
      />
    </svg>

    <svg
      v-if="icon === 'person'"
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4459 28.4459C26.0918 28.4459 30.6688 23.8689 30.6688 18.223C30.6688 12.577 26.0918 8 20.4459 8C14.7999 8 10.2229 12.577 10.2229 18.223C10.2229 23.8689 14.7999 28.4459 20.4459 28.4459Z"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-miterlimit="10"
      />
      <path
        d="M5 37.8351C6.57008 35.115 8.82855 32.8562 11.5484 31.2858C14.2682 29.7153 17.3535 28.8885 20.4942 28.8885C23.6348 28.8885 26.7202 29.7153 29.44 31.2858C32.1598 32.8562 34.4183 35.115 35.9884 37.8351"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'house'"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6194 32.912V25.4532C23.6194 25.1235 23.4885 24.8073 23.2553 24.5742C23.0222 24.3411 22.706 24.2101 22.3763 24.2101H17.4038C17.0741 24.2101 16.7579 24.3411 16.5248 24.5742C16.2916 24.8073 16.1606 25.1235 16.1606 25.4532V32.912C16.1606 33.2417 16.0297 33.5579 15.7965 33.7911C15.5634 34.0242 15.2472 34.1552 14.9175 34.1552H7.45871C7.12901 34.1552 6.81281 34.0242 6.57968 33.7911C6.34655 33.5579 6.21558 33.2417 6.21558 32.912V18.5383C6.21836 18.3663 6.25554 18.1965 6.32492 18.0391C6.39431 17.8816 6.4945 17.7396 6.61959 17.6215L19.0509 6.32452C19.2801 6.11487 19.5794 5.9986 19.89 5.9986C20.2006 5.9986 20.5 6.11487 20.7292 6.32452L33.1605 17.6215C33.2856 17.7396 33.3858 17.8816 33.4552 18.0391C33.5246 18.1965 33.5617 18.3663 33.5645 18.5383V32.912C33.5645 33.2417 33.4335 33.5579 33.2004 33.7911C32.9673 34.0242 32.6511 34.1552 32.3214 34.1552H24.8626C24.5329 34.1552 24.2167 34.0242 23.9836 33.7911C23.7504 33.5579 23.6194 33.2417 23.6194 32.912Z"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'group-people'"
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33 42.3438C36.9695 42.3438 40.1875 39.1258 40.1875 35.1562C40.1875 31.1867 36.9695 27.9688 33 27.9688C29.0305 27.9688 25.8125 31.1867 25.8125 35.1562C25.8125 39.1258 29.0305 42.3438 33 42.3438Z"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M45.2188 30.8438C46.893 30.841 48.5447 31.2294 50.0422 31.9782C51.5397 32.7269 52.8415 33.8152 53.8438 35.1563"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.1562 35.1563C13.1585 33.8152 14.4603 32.7269 15.9578 31.9782C17.4553 31.2294 19.107 30.841 20.7812 30.8438"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.6499 48.8125C23.5965 46.8739 25.0686 45.24 26.8985 44.0972C28.7284 42.9543 30.8425 42.3484 32.9999 42.3484C35.1573 42.3484 37.2714 42.9543 39.1013 44.0972C40.9312 45.24 42.4033 46.8739 43.3499 48.8125"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.7812 30.8437C19.6899 30.8449 18.6208 30.5354 17.6988 29.9514C16.7768 29.3675 16.04 28.5332 15.5746 27.5461C15.1091 26.559 14.9342 25.4598 15.0702 24.377C15.2063 23.2941 15.6477 22.2724 16.3429 21.4311C17.038 20.5898 17.9583 19.9637 18.9961 19.626C20.0338 19.2883 21.1463 19.2529 22.2034 19.5239C23.2606 19.7949 24.2188 20.3612 24.966 21.1566C25.7133 21.952 26.2188 22.9436 26.4234 24.0156"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M39.5767 24.0156C39.7813 22.9436 40.2868 21.952 41.034 21.1566C41.7813 20.3612 42.7395 19.7949 43.7966 19.5239C44.8538 19.2529 45.9662 19.2883 47.004 19.626C48.0418 19.9637 48.962 20.5898 49.6572 21.4311C50.3524 22.2724 50.7938 23.2941 50.9298 24.377C51.0659 25.4598 50.8909 26.559 50.4255 27.5461C49.96 28.5332 49.2233 29.3675 48.3013 29.9514C47.3793 30.5354 46.3102 30.8449 45.2188 30.8437"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="icon === 'calendar'"
    >
      <path
        d="M30.0625 5.78125H6.9375C6.29892 5.78125 5.78125 6.29892 5.78125 6.9375V30.0625C5.78125 30.7011 6.29892 31.2188 6.9375 31.2188H30.0625C30.7011 31.2188 31.2188 30.7011 31.2188 30.0625V6.9375C31.2188 6.29892 30.7011 5.78125 30.0625 5.78125Z"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.4375 3.46875V8.09375"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.5625 3.46875V8.09375"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.78125 12.7188H31.2188"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'music-note'"
      width="37"
      height="38"
      viewBox="0 0 37 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.8575 29.129C28.0789 29.129 29.8798 27.3281 29.8798 25.1067C29.8798 22.8852 28.0789 21.0844 25.8575 21.0844C23.636 21.0844 21.8352 22.8852 21.8352 25.1067C21.8352 27.3281 23.636 29.129 25.8575 29.129Z"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.47004 33.7258C9.69148 33.7258 11.4923 31.925 11.4923 29.7036C11.4923 27.4821 9.69148 25.6813 7.47004 25.6813C5.24859 25.6813 3.44775 27.4821 3.44775 29.7036C3.44775 31.925 5.24859 33.7258 7.47004 33.7258Z"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.8798 11.8906L11.4922 16.4875"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.4922 29.7035V9.59213L29.8798 4.99524V25.1066"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'automation'"
      width="60"
      height="60"
      viewBox="0 0 41 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4998 35.3509C23.1125 35.3509 25.2306 33.2236 25.2306 30.5995C25.2306 27.9753 23.1125 25.848 20.4998 25.848C17.8871 25.848 15.769 27.9753 15.769 30.5995C15.769 33.2236 17.8871 35.3509 20.4998 35.3509Z"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.3398 25.9173C27.5771 26.2585 27.7848 26.6195 27.9607 26.9963L30.5134 28.4217C30.8321 29.8555 30.8355 31.3419 30.5232 32.7772L27.9607 34.2026C27.7848 34.5794 27.5771 34.9404 27.3398 35.2816L27.3891 38.2216C26.3073 39.2117 25.0269 39.9576 23.634 40.4092L21.1208 38.8947C20.7074 38.9244 20.2924 38.9244 19.879 38.8947L17.3756 40.3993C15.9784 39.9559 14.6938 39.2129 13.6107 38.2216L13.66 35.2915C13.4247 34.9456 13.2171 34.5815 13.0391 34.2026L10.4864 32.7772C10.1677 31.3434 10.1643 29.857 10.4766 28.4217L13.0391 26.9963C13.215 26.6195 13.4227 26.2585 13.66 25.9173L13.6107 22.9773C14.6925 21.9872 15.9729 21.2413 17.3658 20.7897L19.879 22.3042C20.2924 22.2745 20.7074 22.2745 21.1208 22.3042L23.6242 20.7996C25.0214 21.243 26.306 21.986 27.3891 22.9773L27.3398 25.9173Z"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M31.5386 24.3297H36.4997V19.1168"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.125 30.1045C5.12388 27.0495 6.02499 24.0628 7.71434 21.5223C9.40369 18.9818 11.8054 17.0017 14.6155 15.8324C17.4256 14.6632 20.5179 14.3573 23.5011 14.9537C26.4843 15.55 29.2244 17.0216 31.3746 19.1824L36.4996 24.3298"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.46143 35.2853H4.50029V40.4982"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M35.875 29.5104C35.8761 32.5654 34.975 35.5521 33.2857 38.0926C31.5963 40.6332 29.1946 42.6133 26.3845 43.7825C23.5744 44.9518 20.4821 45.2576 17.4989 44.6613C14.5157 44.065 11.7756 42.5933 9.62539 40.4326L4.50039 35.2852"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'plus'"
      width="37"
      height="38"
      viewBox="0 0 37 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.78125 19.0432H31.2188"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5 6.3244V31.7619"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'sign-out'"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 10.8837L27 16.1337L21.75 21.3837"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 16.1337H27"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 27.1337H6C5.73478 27.1337 5.48043 27.0283 5.29289 26.8408C5.10536 26.6532 5 26.3989 5 26.1337V6.13367C5 5.86845 5.10536 5.6141 5.29289 5.42656C5.48043 5.23902 5.73478 5.13367 6 5.13367H13"
        stroke="var(--contrastColor)"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="icon === 'settings'"
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5001 16.3509C14.1128 16.3509 16.2308 14.2236 16.2308 11.5995C16.2308 8.97532 14.1128 6.84802 11.5001 6.84802C8.88732 6.84802 6.76929 8.97532 6.76929 11.5995C6.76929 14.2236 8.88732 16.3509 11.5001 16.3509Z"
        stroke="currentColor"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3399 6.91739C18.5772 7.25858 18.7849 7.61956 18.9608 7.99637L21.5135 9.4218C21.8322 10.8556 21.8356 12.342 21.5233 13.7773L18.9608 15.2027C18.7849 15.5795 18.5772 15.9405 18.3399 16.2817L18.3892 19.2217C17.3074 20.2118 16.027 20.9577 14.6342 21.4093L12.1209 19.8948C11.7075 19.9245 11.2925 19.9245 10.8791 19.8948L8.37575 21.3994C6.97851 20.956 5.69389 20.213 4.61085 19.2217L4.66013 16.2916C4.42484 15.9457 4.21722 15.5816 4.03921 15.2027L1.48657 13.7773C1.16783 12.3435 1.16447 10.8571 1.47671 9.4218L4.03921 7.99637C4.21512 7.61956 4.42285 7.25858 4.66013 6.91739L4.61085 3.97744C5.69267 2.98732 6.97306 2.24138 8.36589 1.78979L10.8791 3.30432C11.2925 3.27462 11.7075 3.27462 12.1209 3.30432L14.6243 1.79969C16.0216 2.24306 17.3062 2.98612 18.3892 3.97744L18.3399 6.91739Z"
        stroke="currentColor"
        stroke-width="2px"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: ["icon"],
};
</script>
<style scoped>
.navigation-icon {
  -webkit-transition: background-color 1000ms linear;
  -moz-transition: background-color 1000ms linear;
  -o-transition: background-color 1000ms linear;
  -ms-transition: background-color 1000ms linear;
  transition: background-color 1000ms linear;
  background-color: var(--secondaryColor);
  width: 40px;
  height: 40px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

svg {
  height: 60%;
  stroke-width: 1;
}
</style>
